import SingleStoryPage from './SingleStoryPage-Container';
export default SingleStoryPage;
